import dynamic from 'next/dynamic'
import router from 'next/router'
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

const QuickBuyDialog = dynamic(() => import('@bluheadless/ui/src/organisms/quick-buy/quick-buy-dialog'), {
	ssr: false,
})

const QuickBuyContext = createContext()

const DEFAULT_QUICK_BUY_PROPS = {}

const QuickBuyProvider = ({ children }) => {
	const [open, setOpen] = useState(false)
	const [quickBuyProps, setQuickBuyProps] = useState(DEFAULT_QUICK_BUY_PROPS)

	const closeQuickBuy = useCallback(() => {
		setOpen(false)
		setQuickBuyProps(DEFAULT_QUICK_BUY_PROPS)
	}, [])

	const contextValue = useMemo(
		() => [
			{ quickBuyOpened: open },
			{
				openQuickBuy: (props) => {
					setQuickBuyProps(props)
					setOpen(true)
				},
				closeQuickBuy,
			},
		],
		[closeQuickBuy, open]
	)

	useEffect(() => {
		router.events.on('routeChangeStart', closeQuickBuy)
		return () => {
			router.events.off('routeChangeStart', closeQuickBuy)
		}
	}, [closeQuickBuy])

	return (
		<QuickBuyContext.Provider value={contextValue}>
			{children}
			<QuickBuyDialog open={open} onClose={closeQuickBuy} showButtonClose quickBuyProps={quickBuyProps} />
		</QuickBuyContext.Provider>
	)
}

export default QuickBuyProvider
export const useQuickBuy = () => useContext(QuickBuyContext)
